import { render } from "./DeveloperItemImage.vue?vue&type=template&id=f033d4f0"
import script from "./DeveloperItemImage.vue?vue&type=script&lang=js"
export * from "./DeveloperItemImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__